module.exports = __webpack_public_path__ + "band_17_son.ee088a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_17_son.png
// module id = Lonk
// module chunks = 0